// import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// models
import { ModalData } from '../../../models/modal.interface';
import { BookerItem } from '../../../../booking/models/booking.interface';
// services
import { ErrorHandler } from '../../../services/error-handler.service';
import { BookingService } from '../../../../booking/services/booking.service';
import { LoginService } from '../../../services/login.service';
// shared functions
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { interval, Subscription } from 'rxjs';
import { map, take, takeWhile } from 'rxjs/operators';
// globals
import { COUNTRY_CODES, EMAIL_PATTERN } from '../../../globals';

declare var exponea: any;

@Component({
  selector: 'app-save-pereferences-modal',
  templateUrl: './save-pereferences-modal.component.html',
  styleUrls: ['./save-pereferences-modal.component.scss']
})
export class SavePereferencesModalComponent implements OnInit {

  @ViewChild('form') form;

  @Input()
  modalData: ModalData;
  @Input() appCopy;
  @Input() selectedLanguage;
  @Input() modalList;

  @Output()
  closeModal: EventEmitter<any> = new EventEmitter();

  private _routeParamsSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _otpSubscription: Subscription;
  private _validateOTPCodeSubscription: Subscription;
  private _userSubscription: Subscription;
  private _expressCheckoutCommsPrefSubscription: Subscription;
  private _intervalSubscription: Subscription;

  public showhasMarketingCheck = true;
  public emailPattern = EMAIL_PATTERN;
  public bookerData: BookerItem = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    countryCode: '44',
    hasNotEmailMarketingEnrolment: false,
    hasSmsMarketingEnrolment: false
  };
  public fetchedData: any;
  public dataChanged = false;
  public emailUpdaed: boolean = false;
  public phoneNumberValid = false;
  public user: any;
  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all]
  }

  public isChangePreferences = false;
  public isEditPreferences = false;

  public showOTPLoader = false;
  public showLoginLoader = false;

  private _modalSubscription: Subscription;
  private _validatePhoneNumberSubscription: Subscription;

  private _bookingJourneyReference = '';
  public currentUserEmail = '';
  public currentUserPhoneNumber = '';
  public currentUsercountryCode = '';

  public savePreferenceLoader = false;
  public isCounting = false;
  public countdown = 1;

  public expressModalOTP = false;

  constructor(
    private _appStore: Store<AppState>,
    private _activatedRoute: ActivatedRoute,
    private _bookingService: BookingService,
    private _errorService: ErrorHandler,
    private _loginService: LoginService,
  ) { }

  ngOnInit(): void {
    // subscribe to router query string

    this.setCurrentVariables();

    this.showhasMarketingCheck = this.modalData.hasMarketingEnrolment;
    this.bookerData.hasNotEmailMarketingEnrolment = !this.modalData.hasMarketingEnrolment;

    this._expressCheckoutCommsPrefSubscription = this._bookingService.expressCheckoutCommsPref$
      .subscribe(res => {
        this.savePreferenceLoader = false;

        if (res.error) {
          this._errorService.handleCustomError({
            text: res.message || 'Something went wrong, please try again later.',
            type: 'error',
            sticky: false
          });
          return;
        }
        if (res === 'remove') {
          this._errorService.removeModal();
          this.closeModal.emit();
          return;
        }
      });

    this._routeParamsSubscription = this._activatedRoute.queryParams
      .subscribe((params: any) => {
        if (typeof params.ref !== 'undefined') {
          this._bookingJourneyReference = params.ref;
        }
      },
        err => console.log(err));

    this._bookingInitSubscription = this._appStore.select('userReducer')
      .subscribe((res: any) => {
        // check logged in user email.
        this.user = res.userDetails;

        if (this.user.userTokenValid) {
          this._bookingService.setApiToken(this.user.userToken);
        }
      })

    this._validatePhoneNumberSubscription = this._bookingService.validPhoneNumberSubject$
      .subscribe(valid => {
        if (!valid) {
          this.form?.controls['contactPhone']?.setErrors({ 'incorrect': true });
          this.phoneNumberValid = false;
        } else {
          this.form?.controls['contactPhone']?.setErrors(null);
          this.phoneNumberValid = true;
        }
      });

    this._modalSubscription = this._errorService.modalItem$
      .subscribe(modalItem => {

        if (modalItem === 'remove') {
          // No banner/consent fired here: the opt-in checkbox for this modal is
          // commented out in the template (see html ~89-100), so there is no
          // control for the user to express a preference through — the previous
          // exponea.track('consent', ...) here always reported an opt-in on any
          // dismissal (including X/backdrop closes), and duplicated the banner
          // already fired from the inline opt-in button on the confirmation page.
          // Restore tracking here if the checkbox is ever un-commented.
          return;
          let email_check: any = true;
          if (!this.form === undefined) {
            if (this.form.value.hasMarketingEnrolment === true) {
              email_check = 'accept'
            } else {
              email_check = 'reject'
            }
          }

          exponea.track('consent', {
            action: email_check,
            email_id: this.currentUserEmail,
            message: 'Untick this box if you do not wish to be kept informed about special offers, new services and airline partners.'
          });
        }

      });

    this._otpSubscription = this._loginService.forgotPasswordEmailSent$
      .subscribe(emailSent => {
        if (emailSent.error) {
          this.showOTPLoader = false;
          return;
        }

        if (emailSent) {
          const data = {
            text: "OTP sent to Email!",
            type: "info",
          };
          if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
            data.text = 'OTP sent to phone number!';
          }
          this._errorService.handleCustomInfo(data);

        }

        this.showOTPLoader = false;
        this.startCountDown();
      },
        err => console.log(err));

    this._validateOTPCodeSubscription =
      this._loginService.validateOTPCode$.subscribe(
        (res) => {
          this.showLoginLoader = false;
        },
        (err) => console.log(err)
      );

    this._userSubscription = this._loginService.userSubject$
      .subscribe(res => {
        if (res.error) {
          return;
        }

        this.isEditPreferences = false;
        this.isChangePreferences = true;

      });
  }

  setCurrentVariables() {
    let parsedPhoneNumber;
    let countrycode;
    const modal = this.modalData;
    if (modal.paymentType === 0) {
      this.currentUserEmail = modal.preferenceData.email;
      this.bookerData.emailAddress = modal.preferenceData.email;

      parsedPhoneNumber = this._loginService.parsePhoneNumber(modal.preferenceData.shippingAddress.phoneNumber);
      // this._bookingService.validatePhoneNumber(modal.preferenceData.shippingAddress.phoneNumber);
      COUNTRY_CODES.all.find((item) => {
        if (item.countryCodeName === modal.preferenceData.shippingAddress.countryCode) {
          console.log('item.countryName', item.countryName);
          countrycode = item.countryCode
        }
      });
    }
    if (modal.paymentType === 1) {
      this.currentUserEmail = modal.preferenceData.shippingContact.emailAddress;
      this.bookerData.emailAddress = modal.preferenceData.shippingContact.emailAddress;

      parsedPhoneNumber = this._loginService.parsePhoneNumber(modal.preferenceData.shippingContact.phoneNumber);
      // this._bookingService.validatePhoneNumber(modal.preferenceData.shippingContact.phoneNumber);
      COUNTRY_CODES.all.find((item) => {
        if (item.countryName === modal.preferenceData.shippingContact.country) {
          console.log('item.countryName', item.countryName);
          countrycode = item.countryCode
        }
      });
    }
    // Not reachable for PayPal today: complete-section.component.ts no
    // longer populates modal.preferenceData for paymentType 3 (Adyen's raw
    // state.data has no payer email/phone to read - see that file's note).
    // Left here, commented, in case a future change echoes shopper info
    // back from the backend's Adyen /payments call and this becomes usable
    // again. The `if (!parsedPhoneNumber)` fallback below already handles
    // paymentType 3 falling through with no branch, so this modal is safe
    // to open for a PayPal booking as-is - it just shows the existing
    // bookerData defaults instead of anything PayPal-specific.
    // if (modal.paymentType === 3) {
    //   this.currentUserEmail = modal.preferenceData.payerEmail;
    //   this.bookerData.emailAddress = modal.preferenceData.payerEmail;
    //   parsedPhoneNumber = this._loginService.parsePhoneNumber(modal.preferenceData.payerPhone);
    //   countrycode = this.bookerData.countryCode;
    // }

    if (!parsedPhoneNumber) {
      parsedPhoneNumber = { countryCode: '', phone: '' };
    }

    this.bookerData.countryCode = parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode;
    this.bookerData.phoneNumber = parsedPhoneNumber.phone;

    // this.bookerData.hasEmailMarketingEnrolment = ;
    // this.bookerData.hasSMSMarketingEnrolment = ;

    this.currentUsercountryCode = parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode;
    this.currentUserPhoneNumber = parsedPhoneNumber.phone;

    this.fetchedData = JSON.parse(JSON.stringify(this.bookerData))
    console.log(this.bookerData);

    console.log('call validation function', this.bookerData)
    this.validatePhoneNumber(this.bookerData.countryCode, this.bookerData.phoneNumber)

  }

  confirm(e) {
    e.preventDefault();
    this._errorService.removeModal();
    this.closeModal.emit(e);
  }

  editPreferences(e) {
    e.preventDefault();

    if (this.user.userLoggedIn) {
      this.isEditPreferences = false;
      this.isChangePreferences = true;
    } else {
      this.isEditPreferences = true;
      this.showOTPLoader = true;
      this.expressModalOTP = true;
      this._loginService.sendOTP(this.currentUserEmail, null, 'complete');
    }

  }

  sendOTP(e) {
    e.preventDefault();
    this.showOTPLoader = true;
    this._loginService.sendOTP(this.currentUserEmail, null, 'complete');
  }

  startCountDown() {
    if (this.isCounting) return;
    this.isCounting = true;
    this.countdown = 59;

    this._intervalSubscription = interval(1000)
      .pipe(
        takeWhile(() => this.countdown > 1),
        map(() => --this.countdown)
      )
      .subscribe({
        complete: () => {
          this.isCounting = false;
          this.countdown = 1;
        },
      });
  }

  inlineOTPLogin(email, otp,) {
    if (otp.toString().length !== 6) {
      return;
    }
    this.showLoginLoader = true;
    this._loginService.validateOTPCode(otp, email, 'complete');
  }

  canelEditCommunicationPreferences(e) {
    e.preventDefault();
    // reset data
    // currentUserEmail is resolved per payment type in setCurrentVariables()
    // (google: .email, apple: .shippingContact.emailAddress, paypal: .payerEmail)
    this.bookerData.emailAddress = this.currentUserEmail;
    this.bookerData.countryCode = this.currentUsercountryCode;
    this.bookerData.phoneNumber = this.currentUserPhoneNumber;


    this.isEditPreferences = false;
    this.isChangePreferences = false;
  }

  handleSavePreferencesSubmit() {
    const bookerForm = typeof this.form !== 'undefined';
    if (bookerForm && this.form.valid && this._bookingJourneyReference) {
      if (!this.emailPattern.test(this.bookerData.emailAddress)) {
        this.form.controls['bookerEmail'].setErrors({ 'pattern': true });
        return;
      }
      this.savePreferenceLoader = true;
      // call amend api with flag 64
      let currentBookerData = {};
      let data: AppState;
      this._appStore
        .pipe(take(1))
        .subscribe(res => (
          data = res
        ));
      let state = JSON.parse(JSON.stringify(data.d2dReducer.currentBookingProduct === 'abc' ? data.d2dReducer.outboundBooking : data.d2dReducer.inboundBooking));
      const addBookingRequest = JSON.parse(JSON.stringify(state.currentBookingReducer.currentBooking));
      currentBookerData = state.currentBookingReducer.currentBooking.bookingUser;
      const bookerData = {
        ...currentBookerData,
        emailAddress: this.form.value.bookerEmail,
        countryCode: this.form.value.contactCountryCode,
        phoneNumber: this.form.value.contactPhone,
      }
      // this._bookingService.updateNewsletterOptIn(value);
      // this._bookingService.updateSmsMarketingReminder(value);
      // this._bookingService.updateBooker(bookerData);

      addBookingRequest.hasMarketingEnrolment = !this.form.value.hasNotEmailMarketingEnrolment;
      addBookingRequest.smsMarketingReminder = !this.form.value.hasNotEmailMarketingEnrolment;

      addBookingRequest.bookingUser = bookerData;
      state.bookingReducer.bookingDetails.bookerDataBackup = bookerData;
      const amendData = {
        reference: addBookingRequest.bookingJourneyReference,
        flag: 64
      };
      this._bookingService.postAmend(amendData, undefined, addBookingRequest, 'express-checkout-comms-pref', state, this.expressModalOTP);
      // this._loginService.updateUserPreference(this.form.value, this.user.userDetails.userToken, this.user.userDetails.currentUser.userId);
      console.log('button is clicked');
    }
  }

  validatePhoneNumber(countryCode, phoneNumber) {
    this.phoneNumberValid = false;

    const re = /^[0-9\b]+$/;
    console.log('validation function load with value', countryCode, phoneNumber);
    if (phoneNumber !== '' && re.test(phoneNumber) && phoneNumber?.toString()?.length >= 10) {
      const value = '+' + countryCode + phoneNumber;
      console.log(value)
      this._bookingService.validatePhoneNumber(value);
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Prevent if not a digit (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1)).subscribe((s) => (state = s));
    return state;
  }

  ngOnDestroy(): void {
    if (this._bookingInitSubscription) {
      this._bookingInitSubscription.unsubscribe();
    }
    if (this._modalSubscription) { this._modalSubscription.unsubscribe(); }
    if (this._routeParamsSubscription) { this._routeParamsSubscription.unsubscribe(); }
    if (this._validatePhoneNumberSubscription) { this._validatePhoneNumberSubscription.unsubscribe(); }
    if (this._otpSubscription) { this._otpSubscription.unsubscribe() }
    if (this._validateOTPCodeSubscription) { this._validateOTPCodeSubscription.unsubscribe() }
    if (this._userSubscription) { this._userSubscription.unsubscribe() }
    if (this._expressCheckoutCommsPrefSubscription) { this._expressCheckoutCommsPrefSubscription.unsubscribe() }
    if (this._intervalSubscription) { this._intervalSubscription.unsubscribe(); }

  }

}
